export class HelpText {
    id: string;
    routeUrls?: string[];
    header?: HelpTextHeader;
    bodies?: HelpTextBody[];
    footer?: HelpTextFooter;
    createdBy?: string;
    createdDate?: Date;
    modifiedBy?: string;
    modifiedDate?: Date;
}
export class HelpTextHeader {
    text?: string;
}
export class HelpTextBody {
    text?: string;
    listItem?: boolean;
    bold?: boolean;
}
export class HelpTextFooter {
    text?: string;
}
